export default function () {
  return {
    restrict: "A",
    scope: {
      closeModal: "&", // Функция закрытия модалки
      applyFilter: "&", // Функция сохранения данных
      municipalities: "=", // Список муниципальных образований
      filterData: "=", // Данные фильтра,
      searchData: "=", // Данные поиска
    },
    template: require("../view/appeals-filter.html"),
    link: function (scope, element, attrs) {
      // Функция для сброса фильтров
      scope.resetFilter = function () {
        scope.filterData = {
          type: "place",
          municipality: "",
        };
      };
    },
  };
}
